import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { SearchService } from '../../../shared/search/search.service';
import { ComponentID, ActionType, PermissionHelper } from '../../../shared/helpers/permissionshelper';
import { Logging } from '../../../logging';
import { ConfirmDialogService } from '../../../confirm-dialog/ confirm-dialog.service';

declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;

@Component({
  selector: 'app-cashout-approve-email',
  templateUrl: './cashout-approve-email.component.html',
  styleUrls: ['./cashout-approve-email.component.css']
})
export class CashoutApproveEmailComponent implements OnInit {
 
  linkcode : string = null;
  transid: string;
  cashouttrans: any;
  isbank: boolean = false;
  iswallet: boolean = false;
  appslist: any;
  showErrors :Boolean = false;
  loading: boolean;
  hasError: boolean;
  errorMessage: any;
  successMessage : any;
  approving: boolean;
  rejecting : boolean;

  mode: any = null;
  message :string = null;
 

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private route: ActivatedRoute,
    private searchService: SearchService,private componentid : ComponentID ,
    private actiontype: ActionType,private permhelper:PermissionHelper, private confirmDialogService:ConfirmDialogService   ) { }

  ngOnInit() {

    this.route.queryParams.filter(params => params.r)
    .subscribe(params => {
      Logging.log(params); 
      this.linkcode =   decodeURIComponent(params.r);
      Logging.log(this.linkcode); 
      this.getApps();
      this.fetchTrans();
    });
  }

  fetchTrans()
  {
    if(!this.linkcode)
    {
        this.router.navigate(['/dashboard']);
    }
    this.api.post('/accounts/'+ this.auth.getAccountID() + '/uicashout/link',{value : this.linkcode})
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.cashouttrans = res_data.data[0];
        if(res_data.data[0].transaction.channel == "BANK")
        {
          this.isbank = true;
        }
        else if(res_data.data[0].transaction.channel == "MOBILE_MONEY")
        {
          this.iswallet = true;
        }
      }, error_message => {
        this.helpers.flashDanger(error_message);
        this.router.navigate(['/dashboard']);
      }
    );
  }


  getApps(){
  
    this.api.get('/campaigns/accounts/'+ this.auth.getAccountID() + '/apps')
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.appslist = res_data.data.content;
      }, error_message => {
        
      }
    );
  }

getAppName(id: any)
{
  const found = this.appslist.filter(a => a.id== id);
  if(found && found.length > 0)
  {
    return found[0].description;
  }
  return id;
}


reject()
{
  
    const requestpayload = {
      key: this.cashouttrans.transaction.id,
      value: this.linkcode
    };
      
    $('.btn').attr('disabled',true);
    this.rejecting = true;
    this.api.put('/accounts/'+ this.auth.getAccountID() + '/uicashout/rejectbylink',requestpayload)
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      if(res_data.data[0].value == true)
      {
        this.helpers.flashSuccess("Transaction rejected successfully");
        this.router.navigate(['/cashout/pending']);
      }
      else
      {
        this.helpers.flashDanger("Transaction could not be rejected");
      }
      this.rejecting = false;
      }, error_message => {
        this.rejecting = false;
        this.helpers.flashDanger(error_message);
        $('.btn').removeAttr('disabled');
      }
    );
     
  
}
  

approve()
{
   
    const requestpayload = {
      key: this.cashouttrans.transaction.id,
      value: this.linkcode
    };
    this.approving = true;
    $('.btn').attr('disabled',true);
    this.api.put('/accounts/'+ this.auth.getAccountID() + '/uicashout/approvebylink',requestpayload)
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      if(res_data.data[0].value == true)
      {
        this.helpers.flashSuccess("Transaction approved successfully");
        this.router.navigate(['/cashout/pending']);
      }
      else
      {
        this.helpers.flashDanger("Transaction could not be approved");
      }
      
      this.approving = false;
      }, error_message => {
        this.approving = false;
        this.helpers.flashDanger(error_message);
        $('.btn').removeAttr('disabled');
      }
    );
 
  } 

  action(type: any)
  {
    if(this.mode == '1' && type == '1')
    {
        this.approve();
    }
    if(this.mode == '0' && type == '1')
    {
        this.reject();
    }
  }

  confirmaction(action:any)
  {
    this.mode = action;
    if(action == '1')
    {
      this.message= "Are you sure you want to authorize this cashout?";
    }
    else
    {
      this.message= "Are you sure you want to reject this cashout?";
    }

    $("#confirmation").modal({
      escapeClose: false,
      clickClose: false,
      showClose: false
    });

  }
}





// WEBPACK FOOTER //
// ./src/app/client/cashout/cashout-approve-email/cashout-approve-email.component.ts